/**
 * @generated SignedSource<<c6a7dcd2e49df1a7bf49f87615327804>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Position = "freelancer" | "permanent";
export type RateMode = "day" | "hour" | "month" | "week" | "year";
import { FragmentRefs } from "relay-runtime";
export type JobsListingItem_Job$data = {
  readonly clientRate: {
    readonly value: number;
  } | null | undefined;
  readonly currency: {
    readonly code: string | null | undefined;
  } | null | undefined;
  readonly description: string | null | undefined;
  readonly firm: {
    readonly name: string | null | undefined;
    readonly slug: string | null | undefined;
  } | null | undefined;
  readonly freelancerRate: {
    readonly value: number;
  } | null | undefined;
  readonly jobApplication: {
    readonly " $fragmentSpreads": FragmentRefs<"JobsListingItem_JobApplication">;
  } | null | undefined;
  readonly jobSkills: ReadonlyArray<{
    readonly groupIndex: number | null | undefined;
    readonly required: boolean | null | undefined;
    readonly requiredYears: number | null | undefined;
    readonly skill: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly userSkill: {
      readonly experience: number | null | undefined;
    } | null | undefined;
  }>;
  readonly minClientRate: {
    readonly value: number;
  } | null | undefined;
  readonly minFreelancerRate: {
    readonly value: number;
  } | null | undefined;
  readonly positionTypes: ReadonlyArray<Position>;
  readonly rateMode: RateMode | null | undefined;
  readonly slug: string | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"JobShare_Job" | "RateExplanation_Job">;
  readonly " $fragmentType": "JobsListingItem_Job";
};
export type JobsListingItem_Job$key = {
  readonly " $data"?: JobsListingItem_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobsListingItem_Job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobsListingItem_Job",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "positionTypes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rateMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "clientRate",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "minClientRate",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "freelancerRate",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Money",
      "kind": "LinkedField",
      "name": "minFreelancerRate",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Currency",
      "kind": "LinkedField",
      "name": "currency",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Firm",
      "kind": "LinkedField",
      "name": "firm",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobSkill",
      "kind": "LinkedField",
      "name": "jobSkills",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "required",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiredYears",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupIndex",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Skill",
          "kind": "LinkedField",
          "name": "skill",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserSkill",
          "kind": "LinkedField",
          "name": "userSkill",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "experience",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobApplication",
      "kind": "LinkedField",
      "name": "jobApplication",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobsListingItem_JobApplication"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RateExplanation_Job"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobShare_Job"
    }
  ],
  "type": "Job",
  "abstractKey": null
};
})();

(node as any).hash = "5c36bdf7b70c9d23734bd32c00537630";

export default node;
